import { ROUTES_APLICATION } from "@constants/routes-aplication.constants";
import { ApplicationModules } from "@core/enums/application-modules.enum";
import { UserTypeEnum } from "@core/enums/user-type.enum";
import { MenuConfigModel } from "@core/models/outros/menu-config.model";


export const MENU_REPORTS: MenuConfigModel = {
    id: ApplicationModules.REPORTS,
    icon: 'description',
    name: 'relatorios',
    onlyAssociated: true,
    text: 'Aqui você pode verificar os <strong>relatórios</strong>.',
    profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.SUPERVISOR,
        UserTypeEnum.FINANCEIRO,
    ],
    submenus: [
        {
            name: 'Painel Financeiro',
            onlyAssociated: true,
            profilesToShowItems: [
                UserTypeEnum.ADMINISTRADOR,
                UserTypeEnum.SUPERVISOR,
                UserTypeEnum.FINANCEIRO,
            ],
            route: `/${ROUTES_APLICATION.reports.path}/${ROUTES_APLICATION.reports.financialDashboard}`,
        },
        {
            name: 'Extrato Financeiro',
            onlyAssociated: true,
            profilesToShowItems: [
                UserTypeEnum.ADMINISTRADOR,
                UserTypeEnum.SUPERVISOR,
                UserTypeEnum.FINANCEIRO,
            ],
            route: `/${ROUTES_APLICATION.reports.path}/${ROUTES_APLICATION.reports.financialStatement}`,
        },
        {
            name: 'Consolidado Financeiro',
            onlyAssociated: true,
            profilesToShowItems: [
                UserTypeEnum.ADMINISTRADOR,
                UserTypeEnum.SUPERVISOR,
                UserTypeEnum.FINANCEIRO,
            ],
            route: `/${ROUTES_APLICATION.reports.path}/${ROUTES_APLICATION.reports.financialConsolidated}`,
        },
        {
            name: 'Relatório DRE',
            onlyAssociated: true,
            profilesToShowItems: [
                UserTypeEnum.ADMINISTRADOR,
                UserTypeEnum.SUPERVISOR,
                UserTypeEnum.FINANCEIRO,
            ],
            route: `/${ROUTES_APLICATION.reports.path}/${ROUTES_APLICATION.reports.financialDRE}`,
        },
        {
            name: 'Relatório Fluxo de Caixa',
            onlyAssociated: true,
            profilesToShowItems: [
                UserTypeEnum.ADMINISTRADOR,
                UserTypeEnum.SUPERVISOR,
                UserTypeEnum.FINANCEIRO,
            ],
            route: `/${ROUTES_APLICATION.reports.path}/${ROUTES_APLICATION.reports.financialCashFlow}`,
        },
    ],
}